<template>

  <div class="d-flex justify-content-center mt-4">
    <img alt="aizdevums" class="img" src="/shop/images/banner_aizdevums.png">

  </div>

</template>
